import { render, staticRenderFns } from "./VStakeholderCategoryForm.vue?vue&type=template&id=06fb2f14&scoped=true&"
import script from "./VStakeholderCategoryForm.vue?vue&type=script&lang=js&"
export * from "./VStakeholderCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./VStakeholderCategoryForm.vue?vue&type=style&index=0&id=06fb2f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb2f14",
  null
  
)

export default component.exports